export const SET_CONTRACT_DETAIL = 'SET_CONTRACT_DETAIL';
export const SET_CLIENT_DETAIL = 'SET_CLIENT_DETAIL';
export const SET_SUMMARY = 'SET_SUMMARY';
export const SET_REPAYMENT_SCHEDULE = 'SET_REPAYMENT_SCHEDULE';
export const SET_TRANSACTIONS = 'SET_TRANSACTIONS';
export const SET_CONTRACT_DOCS = 'SET_CONTRACT_DOCS';
export const SET_CONTRACT_DOC_TYPES = 'SET_CONTRACT_DOC_TYPES';
export const SET_ASSET = 'SET_ASSET';
export const SET_CONTRACT_NOTES = 'SET_CONTRACT_NOTES';
export const RESET = 'RESET';
